



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import Especificacao from "../components/Especificacao.vue";
import Numeros from "../components/Numeros.vue";

@Component({
  components: {
    Especificacao,
    Numeros,
  },
})
export default class Educacional extends Vue {
  data() {
    return {
      dialogArquivos: false,
      dialogArquivosMD: false,
      dialogVideoFamilia: false,
      dialogVideoEducador: false,
      dialogVideoDiario: false,
      dialogVideoGestor: false,
    };
  }
}
